<login>
  <div if="{ props.valid }">
    <form onsubmit="{ onSubmit }" class="login-form">
      <input name="dummyetel" autocomplete="tel" style="top: -2000px; left: -2000px; position: fixed;" type="tel">
      <input type="password" name="dummypass" autocomplete="current-password"
        style="top: -2000px; left: -2000px; position: fixed;">
      <div id="memo1_before"></div>
      <div class="form-group">
        <label class="form-label" for="phone">電話番号</label>
        <input class="form-control" type="tel" name="phone" id="phone" value="{ state.phone }" required>
      </div>

      <div class="form-group">
        <label class="form-label" for="password">パスワード</label>
        <input class="form-control" type="password" name="password" id="password" value="{ state.password }" required>
      </div>

      <div class="form-group">
        <label for="showPasswordCheck">
          <input type="checkbox" name="showPasswordCheck" id="showPasswordCheck" onchange="{ togglePassword }">
          <small>パスワードを表示する</small>
        </label>
      </div>
      <span id="error-msg">
        { props.errorMsg }
      </span>
      <button id="btn-login" class="btn">ログイン</button>
      <div class="link-group">
        <a class="link" href="#{ props.shopId }/password">
          <i class="fa fa-key"></i>
          パスワードの設定
        </a>
      </div>
      <div class="password-note">(※初めて利用する場合、もしくは、パスワードを忘れた場合)</div>
      <div class="note-group">
        <div id="memo2_before"></div>
      </div>
    </form>
  </div>
  <div if="{ !props.valid }">
    URLが異なります
  </div>
  <script>
    import { removePhoneHyphen, matchPhoneStart } from '@/common/utils/strings';
    import { serializeForm } from '@/common/utils/dom';
    import storage from '@/common/storage';
    import { convertSpwToState } from '@/point/convertSpwToState';
    export default {
      state: {
        phone: storage.getItem('phone'),
        password: storage.getItem('password')
      },

      onMounted() {
        if (!this.props.valid) {
          return;
        }
        const { memo1_before, memo2_before } = convertSpwToState(this.props.web);
        this.update();
        const note1Div = document.getElementById('memo1_before');
        const note2Div = document.getElementById('memo2_before');
        note1Div.insertAdjacentHTML('afterbegin', memo1_before);
        note2Div.insertAdjacentHTML('afterbegin', memo2_before);
      },

      togglePassword() {
        const passwordElement = this.$('#password');
        const type = passwordElement.getAttribute('type');
        this.$('#password').setAttribute('type', type == 'password' ? 'text' : 'password');
      },

      onSubmit(e) {
        e.preventDefault();
        this.$('[name=dummyetel]').value = '';
        const data = serializeForm(e.target);
        data.shopId = this.props.shopId;
        const phone = removePhoneHyphen(data.phone);
        if (!phone.match(/^\d{11}$/)) {
          this.props.openFailedDialog('不正な電話番号です');
          return;
        }
        if (!matchPhoneStart(phone)) {
          this.props.openFailedDialog('携帯番号ではない番号が含まれています');
          return;
        }
        data.phone = phone;
        this.props.login(data);
      }
    };
  </script>
  <style type="postcss">
    .btn {
      margin-top: 16px;
      width: 100%;
    }

    .link-group {
      margin-top: 16px;
    }

    .link+.link {
      margin-left: 14px;
    }

    .note-group{
      margin-top: 15px;
    }

    #error-msg {
      color: red;
      margin: 5px 0;
    }

    @media (max-width: 640px) {
      .login-form {
        width: 100%;
      }

      .btn {
        margin-top: 0;
      }

      .link-group {
        margin-top: 0;
      }

      label[for="showPasswordCheck"] {
        display: flex;
        align-items: center;
        gap: 10px;
        min-height: 38px;
        color: #4d5664;
      }

      #showPasswordCheck {
        width: 22px;
        height: 22px;
        margin: 0;
        accent-color: #2f62b5;
      }

      .note-group{
        margin-top: 0;
      }

      #error-msg {
        margin: 6px 0 0;
      }

      .password-note {
        font-size: 0.7rem;
        line-height: 1.5;
        padding-bottom: 10px;
      }
    }
  </style>
</login>
